import React from "react";
import { FormatMoney } from "../../../Helpers/FormatNumber";

// "80/20 de Clientes por Año" (Pantalla 1). Clic en un grupo ("80"/"20"/
// "total") alimenta el detalle de Familias de TablaFamiliasPorGrupoPareto.
// Detalle completo en README.
export const TablaParetoPorAnio = ({
    datos = [],
    titulo = "80/20 de Clientes por Año",
    grupoSeleccionado,
    onGrupoClick,
}) => {
    const grupos = ["20","80"].map((grupo) => ({
        grupo,
        filas: datos.filter((fila) => fila.grupo === grupo),
    }));

    // Años sin duplicar, en el orden que ya vienen en `datos`.
    const anios = [...new Set(datos.map((fila) => fila.anio))];
    const filasTotal = anios.map((anio) => {
        const fila80 = datos.find((fila) => fila.anio === anio && fila.grupo === "80");
        const fila20 = datos.find((fila) => fila.anio === anio && fila.grupo === "20");
        return {
            anio,
            clientes: (fila80?.clientes || 0) + (fila20?.clientes || 0),
            monto: (fila80?.monto || 0) + (fila20?.monto || 0),
        };
    });

    return (
        <div className="tabla-pareto-anio">
            <div className="tpa-titulo">{titulo}</div>
            <div className="tpa-header">
                <div className="tpa-header-spacer" />
                <div className="tpa-header-cols">
                    <span>Periodo</span>
                    <span>Clientes</span>
                    <span>% Clientes</span>
                    <span>Monto</span>
                </div>
            </div>
            <div className="tpa-body scroll">
                {datos.length === 0 && (
                    <div className="tpa-vacio">Sin datos para los años mostrados.</div>
                )}
                {datos.length > 0 &&
                    grupos.map(({ grupo, filas }) => (
                        <div
                            className={`tpa-grupo tpa-grupo--${grupo}${grupo === grupoSeleccionado ? " tpa-grupo--seleccionado" : ""
                                }${typeof onGrupoClick === "function" ? " tpa-grupo--clickable" : ""}`}
                            key={grupo}
                            onClick={() => onGrupoClick && onGrupoClick(grupo)}
                        >
                            <div className="tpa-grupo-label">{grupo}%</div>
                            <div className="tpa-grupo-filas">
                                {filas.map((fila) => (
                                    <div className="tpa-row" key={`${grupo}-${fila.anio}`}>
                                        <span>{fila.anio}</span>
                                        <span>{fila.clientes}</span>
                                        <span>{fila.porcentajeClientes.toFixed(2)}%</span>
                                        <span>${FormatMoney(fila.monto, 2)}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                {datos.length > 0 && (
                    <div
                        className={`tpa-grupo tpa-grupo--total${"total" === grupoSeleccionado ? " tpa-grupo--seleccionado" : ""
                            }${typeof onGrupoClick === "function" ? " tpa-grupo--clickable" : ""}`}
                        onClick={() => onGrupoClick && onGrupoClick("total")}
                    >
                        <div className="tpa-grupo-label">Total</div>
                        <div className="tpa-grupo-filas">
                            {filasTotal.map((fila) => (
                                <div className="tpa-row" key={`total-${fila.anio}`}>
                                    <span>{fila.anio}</span>
                                    <span>{fila.clientes}</span>
                                    <span>100.00%</span>
                                    <span>${FormatMoney(fila.monto, 2)}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};
